export const StarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 2 25 25"
    fill="none"
  >
    <g clipPath="url(#clip0_2027_59268)">
      <path
        d="M12.5742 3.64941L15.5742 9.64941L21.5742 12.6494L15.5742 15.6494L12.5742 21.6494L9.57422 15.6494L3.57422 12.6494L9.57422 9.64941L12.5742 3.64941Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2027_59268">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.574219 0.649414)"
        />
      </clipPath>
    </defs>
  </svg>
);
